import { defineComponent as _defineComponent } from 'vue'
import { computed, isRef, useAttrs, useSlots } from 'vue';
import { NumberInputData } from './types';

export interface NumberInputProps {
    data: NumberInputData;
    moneyOptions?: Record<string, any>;
    onBlur?: (value: any) => void;
    onPaste?: (event: ClipboardEvent) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberInput',
  props: {
    data: null,
    moneyOptions: null,
    onBlur: null,
    onPaste: null
  },
  emits: ["enter"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'enter'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    data: NumberInputData;
    moneyOptions?: Record<string, any>;
    onBlur?: (value: any) => void;
    onPaste?: (event: ClipboardEvent) => void;
};




const slots = useSlots();
const attrs = useAttrs();

const resolvedValue = computed(() => {
    const current = props.data.value;
    const val = isRef(current) ? current.value : current;
    return val;
});

const setValue = (value: string | number) => {
    const current = props.data.value;

    if (isRef(current)) {
        current.value = value;
        return;
    }
    props.data.value = +value;
};

const handleBlur = (e: any) => {
    if (props.onBlur) {
        props.onBlur(e.target.value);
        return;
    }
};

const handleInput = (event: Event) => {
    const target = event.target as HTMLInputElement;
    setValue(target.value);
};

const handlePaste = (event: ClipboardEvent) => {
    if (props.onPaste) {
        props.onPaste(event);
    }
};

const handleKeyUp = () => {
    emit('enter');
};

return { __sfc: true,props, emit, slots, attrs, resolvedValue, setValue, handleBlur, handleInput, handlePaste, handleKeyUp }
}

})